export default "__VITE_ASSET__BgHS8gLl__"